<template>
  <div class="combobox-container">
    <input
      class="input-text"
      type="text"
      :value="modelValue"
      @input="input($event.target)"
      v-bind="$attrs"
      :class="{error:error}"
      :list="datalistId"
    >
    <p class="input-error" v-if="error">{{ error }}</p>
    <datalist :id="datalistId">
      <option 
        v-for="(option,index) in selectOptions" 
        :key="index"
      >
        {{ option.label }}
      </option>
    </datalist>
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  props: ['modelValue', 'options', 'error'],
  emits:['update:modelValue', 'update'],
  setup(props, context) {
    // データリストのIDをランダムに生成
    const datalistId = 'datalist-'+ Math.random().toString(36).substring(7)
    const selectOptions = computed(() => {
      const options = Object.assign([], props.options)
      return options
    })
    const input = (target: EventTarget  | null) => {
      target as HTMLInputElement
      if(target instanceof HTMLInputElement){
        context.emit('update:modelValue', target.value)
        context.emit('update', target.value)
      }
    }
    return {
      datalistId,
      selectOptions,
      input
    }
  }
})
</script>
